import React from 'react';
import {ReactComponent as EditSvg} from '../../../../assets/images/archive/edit.svg';
import {ReactComponent as MailSvg} from '../../../../assets/images/archive/mail.svg';
import {ReactComponent as ViewSvg} from '../../../../assets/icons/view.svg';
import StatusCard from './StatusCard';
import {useDispatch} from 'react-redux';
import {setModal} from '../../../../redux/actions/app/appActions';
import {POPUPS} from '../../../../redux/actions/app/appActionTypes';
import {setEditMailingData} from '../../../../redux/actions/mailing/mailingActions';
import dayjs from 'dayjs';
import {dateFormatWithTime} from '../../../../helpers/constants';
import {IconButtonMUI} from '../../../../shared';
import {useTranslation} from 'react-i18next';

const Cards = ({archiveArr}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const handleShowMailingPopup = (archive) => {
    dispatch(
      setEditMailingData({
        data: archive,
        isView: false
      })
    );
    dispatch(setModal(POPUPS.MAILING_POPUP));
  };
  const handleShowMailingPopupView = (archive) => {
    dispatch(
      setEditMailingData({
        data: archive,
        isView: true
      })
    );
    dispatch(setModal(POPUPS.MAILING_POPUP));
  };

  return (
    <div className={'archive__list'}>
      {archiveArr.map((archive, idx) => {
        return (
          <div className={'archive__item'} key={idx}>
            <div className='archive__info'>
              <div className='archive__icon'>
                <MailSvg />
              </div>
              <div className='archive__data'>
                <h3 className='archive__name'>{t('header.mailing')} {idx + 1}</h3>
                <div className='archive__details'>
                  <StatusCard status={!archive.planned ? 'planned' : 'send'} />
                  <p className={'archive__date'}>
                    {archive.sentAt ? dayjs(archive.sentAt).format(dateFormatWithTime) : ''}
                  </p>
                </div>
              </div>
            </div>
            <div className='archive__items'>
              <div className='archive__view' onClick={() => handleShowMailingPopupView(archive)}>
                <IconButtonMUI color={'inherit'} title={t('all.view')}>
                  <ViewSvg />
                </IconButtonMUI>
              </div>
              <div className='archive__edit' onClick={() => handleShowMailingPopup(archive)}>
                <IconButtonMUI color={'inherit'} title={t('dictionaries.edit')}>
                  <EditSvg />
                </IconButtonMUI>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Cards;
